import { QueryClient } from '@tanstack/react-query';
import { Work } from '../../types/design';
import Api from '../Api';

interface SavedDesignsResponse {
  designs: Work[];
  total: number;
}

interface GetWorksParameters {
  offset: number;
  pageSize: number;
  sortBy: string;
}

interface DuplicateDocRefResponse {
  documentReference: string;
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      gcTime: Infinity,
      placeholderData: (previousData: unknown) => previousData,
    },
  },
});

class DesignService extends Api {
  queryClient = queryClient;

  async getWorks(parameters: GetWorksParameters): Promise<SavedDesignsResponse> {
    const { data } = await this.httpClient.get<SavedDesignsResponse>(
      '/works',
      { params: parameters },
    );
    return Promise.resolve(data);
  }

  async editWorkName(workId: string, workName: string): Promise<void> {
    await this.httpClient.patch(
      `/works/${workId}/name`,
      { workName },
    );
  }

  async deleteWork(workId: string, undo: boolean = false) {
    await this.httpClient.patch(
      `/works/${workId}/setVisible`,
      { hidden: !undo },
    );
  }

  /**
   * Copies a given document reference
   * @returns {string}
   * @param documentReferenceUrl
   */
  async duplicateDocRef(documentReferenceUrl: string): Promise<string> {
    const { data } = await this.httpClient.post<DuplicateDocRefResponse>(
      `/doc-ref/duplicate?documentReference=${documentReferenceUrl}`,
    );
    return data.documentReference;
  }
}

export default DesignService;
